// extracted by mini-css-extract-plugin
module.exports = {"patientName":"Table_patientName__2LPiI","productName":"Table_productName__toBtF"};